export default ['bold', 'italic', 'underline', 'link', { color: [] }];
